<h1 *ngIf="showError" class="vc-external-login-greeting headline-l">Login Error</h1>
<div *ngIf="showError" class="vc-external-login-text body-m-1">
    <p>{{ generalError }}</p>
    <p *ngIf="error">{{ 'Error: ' + error }}</p>
</div>
